module.exports = __webpack_public_path__ + "static/media/16.9f5bafc4.jpg";